<template>
    <div v-if="statusRows.length" class="vehicle-status-panel">
        <div v-for="status in statusRows" :key="status.key" class="vehicle-status-row">
            <span class="vehicle-status-label">{{ status.label }}</span>
            <span class="vehicle-status-value">
                <component :is="status.component" v-bind="{ [status.prop]: status.value }" />
            </span>
        </div>
    </div>
</template>

<script>
import BatteryDisplay from '@/components/display/BatteryDisplay.vue'
import PowerConnectedDisplay from '@/components/display/PowerConnectedDisplay.vue'
import AlimDisplay from '@/components/display/AlimDisplay.vue'
import SpeedDisplay from '@/components/display/SpeedDisplay.vue'
import GSMDisplay from '@/components/display/GSMDisplay.vue'
import GPSDisplay from '@/components/display/GPSDisplay.vue'

export default {
    name: 'VehicleStatusesDisplay',
    components: {
        BatteryDisplay,
        PowerConnectedDisplay,
        AlimDisplay,
        SpeedDisplay,
        GSMDisplay,
        GPSDisplay
    },
    props: {
        balise: {
            type: Object,
            required: true
        }
    },
    computed: {
        statusRows() {
            const rows = [
                {
                    key: 'battery',
                    label: 'Bat',
                    component: 'BatteryDisplay',
                    prop: 'battery',
                    value: this.balise?.lastBattery
                },
                {
                    key: 'power',
                    label: 'Alim',
                    component: 'PowerConnectedDisplay',
                    prop: 'powerConnected',
                    value: this.balise?.powerConnected
                },
                {
                    key: 'alim',
                    label: 'Volt',
                    component: 'AlimDisplay',
                    prop: 'alim',
                    value: this.balise?.lastPowerVoltage
                },
                {
                    key: 'gps',
                    label: 'GPS',
                    component: 'GPSDisplay',
                    prop: 'gps',
                    value: this.balise?.lastLevelGPS
                },
                {
                    key: 'gsm',
                    label: 'GSM',
                    component: 'GSMDisplay',
                    prop: 'gsm',
                    value: this.balise?.lastLevelGSM
                },
                {
                    key: 'speed',
                    label: 'Vit',
                    component: 'SpeedDisplay',
                    prop: 'speed',
                    value: this.balise?.lastSpeed
                }
            ];

            return rows.filter((row) => row.value != null);
        }
    }
}
</script>

<style scoped>
.vehicle-status-panel {
    flex: 0 0 118px;
    width: 118px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    min-width: 0;
    padding-right: 0;
}

.vehicle-status-row {
    display: grid;
    grid-template-columns: 34px 1fr;
    align-items: center;
    column-gap: 6px;
    min-width: 0;
    line-height: 1;
}

.vehicle-status-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: rgba(15, 23, 42, 0.55);
    text-transform: uppercase;
    text-align: left;
    white-space: nowrap;
}

.vehicle-status-value {
    min-width: 0;
    width: 100%;
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
}

.vehicle-status-value :deep(*) {
    font-size: 11px;
    line-height: 1;
}

.vehicle-status-value :deep(svg) {
    width: 14px;
    height: 14px;
}

.vehicle-status-value :deep(.ui-badge) {
    width: 72px;
    min-width: 72px;
    padding: 2px 6px;
    font-size: 10px;
    justify-content: center;
    text-align: center;
    display: inline-flex;
    align-items: center;
}

@media (max-width: 767.98px) {
    .vehicle-status-panel {
        flex: 0 0 108px;
        width: 108px;
    }

    .vehicle-status-row {
        grid-template-columns: 28px 1fr;
        column-gap: 6px;
    }

    .vehicle-status-label {
        font-size: 10px;
    }

    .vehicle-status-value :deep(.ui-badge) {
        width: 64px;
        min-width: 64px;
    }
}
</style>